import { render, staticRenderFns } from "./ListPoint.vue?vue&type=template&id=45f3ac18&"
import script from "./ListPoint.vue?vue&type=script&lang=js&"
export * from "./ListPoint.vue?vue&type=script&lang=js&"
import style0 from "./ListPoint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports